// // Segregated API Paths

const AUTH = {
  login: "/accounts/api/v1/login/",
  loginOTP: "/accounts/api/v1/login/token/",
  verifyPhone: "/accounts/api/v1/mobile-verify/",
  refresh: "/accounts/api/v1/token/refresh/",
  profile: "/accounts/api/v1/user/me/",
  profileResources: "/accounts/api/v1/resources/",
  CustomerUserProfile: "/accounts/api/v1/user/profile/",
  userSettings: "/accounts/api/v1/user/profile/",
};

const BASE = {
  org: "organization/api/v1/organization/",
  organizationAddress: (id) => `organization/api/v1/organizationaddress/${id}/`,
  orgGetDashboards: "organization/api/v1/dashboards/",
  branding: "/organization/api/v2/organization-branding/",
};

const SITES = {
  sites: (customer_id) => `organization/api/v1/customer/${customer_id}/site/`,
  location: (customer_id, site_id) =>
    `organization/api/v1/customer/${customer_id}/site/${site_id}/location/`,
};

const INTERCOM = {
  claim_controller: (customer_id, site_id, location_id) =>
    `organization/api/v1/customer/${customer_id}/site/${site_id}/location/${location_id}/claim/controller/`,
  unclaim_controller: (customer_id, site_id, location_id) =>
    `organization/api/v1/customer/${customer_id}/site/${site_id}/location/${location_id}/unclaim/controller/`,
};

const SYSTEM = {
  controller_edit: (mac_id) => `system/api/v1/controllers/${mac_id}/`,
  controllers_new_list: (customer_id, site_id, location_id) =>
    `organization/api/v1/customer/${customer_id}/site/${site_id}/location/${location_id}/controllers/`,

  inventories_new_list: (customer_id, site_id) =>
    `organization/api/v1/customer/${customer_id}/site/${site_id}/controllers/`,

  ethernet_configurations: (mac_id) => `system/api/v1/controllers/${mac_id}/ethernet/`,
  wifi_configurations: (mac_id) =>
    `system/api/v1/controllers/${mac_id}/wifi_configuration/`,
  port_forwarding_configurations: (mac_id) =>
    `system/api/v1/controllers/${mac_id}/portfwd/`,

  telemetry: (mac_id) => `system/api/v1/controllers/${mac_id}/telemetry/`,
  editEthernet: (mac_id) => `system/api/v1/controllers/${mac_id}/ethernet/`,

  systemInventories: (mac_id) => `system/api/v1/systeminventory/${mac_id}/`,

  summary: (mac_id) => `/system/api/v2/inventory-sensors/?controller_pk=${mac_id}`,
  summarySensor: (mac_id, sensorId) =>
    `system/api/v1/controllers/${mac_id}/inventorysensor/${sensorId}/`,

  testFeed: (mac_id, sensor_id) =>
    `system/api/v1/controllers/${mac_id}/sensors/${sensor_id}/testfeed/`,

  addSlugFeed: (mac_id, sensor_id) =>
    `system/api/v1/controllers/${mac_id}/sensors/${sensor_id}/slugfeed/`,

  resetPortForward: (mac_id) =>
    `system/api/v1/controllers/${mac_id}/portfwd/featureenable/`,

  emailTransmission: (mac) => `system/api/v1/controllers/${mac}/email-transmission/`,

  systemLogs: (mac_id) => `system/api/v1/controllers/${mac_id}/logs/`,
  analogBank: (mac_id) => `system/api/v1/controllers/${mac_id}/analog_bank/`,
  favourite: (mac_id) => `system/api/v1/fav/inventory/${mac_id}/`,
  favourites: () => "system/api/v1/fav/inventory/",
  calibrate: (mac_id, sensorId) =>
    `system/api/v1/controllers/${mac_id}/sensors/${sensorId}/calibrate/`,
  calibrationHistory: (mac_id, sensorId) =>
    `system/api/v1/controllers/${mac_id}/sensors/${sensorId}/calibration_history/`,
  modbus: (mac_id) => `system/api/v1/controllers/${mac_id}/modbus/`,
  cellularModem: (mac_id) => `system/api/v1/controllers/${mac_id}/cellular-modem/`,
  resetController: (mac) => `system/api/v1/controllers/${mac}/reset-controller/`,
  applianceCategory: "core/api/v2/appliance-categories/",
  controllersWithActiveAlert: "organization/api/v1/controllers-activealerts/",
  aquaticGroupProfiles: "core/api/v2/aquatic-group-profiles/",
};

const ADDRESS = {
  getAddress: "organization/api/v1/organizationaddress/",

  addNewAddress: "organization/api/v1/organizationaddress/",

  updateAddress: (org_address_id) =>
    `organization/api/v1/organizationaddress/${org_address_id}/`,

  deleteAddress: (org_address_id) =>
    `organization/api/v1/organizationaddress/${org_address_id}/`,
};

const USERS = {
  listUser: "/accounts/api/v1/user/",
  orgUsers: (currentUser) =>
    `accounts/api/v1/user/get_users_list_label/?is_org_user=true&exclude=${currentUser}`,
  changeOwner: (org_id) =>
    `organization/api/v1/organization/${org_id}/organizationowner/`,
};

const GROUP = {
  listGroup: "/accounts/api/v1/groups/",
  listPermissions: "/accounts/api/v1/permissions/get_permissions_list/",
  listUsers: "/accounts/api/v1/user/get_users_list_label/",
  deleteGroup: (groupId) => `/accounts/api/v1/groups/${groupId}/`,
  group_label_value: "/accounts/api/v1/groups/get_groups_list/",
};

const REPORTS = {
  getReports: (customer_id) => `reports/api/v1/customer/${customer_id}/report/`,
  retrieveReports: (customer_id, reportId) =>
    `reports/api/v1/customer/${customer_id}/report/${reportId}/`,
  getInventoryLabelValue: "system/api/v1/systeminventory/labelvalue/",
  templateControllers: "/reports/api/v1/controllers/",
  testSensor: (mac) => `/reports/api/v1/controllers/${mac}/result_sensors/`,
  nonTestTemplate: "/reports/api/v1/manual-result-templates/",
  templates: "/reports/api/v1/templates/",
  reports: "/reports/api/v1/reports/",
};

const TEMPLATES = {
  getTemplates: (customer_id) => `reports/api/v1/customer/${customer_id}/template/`,
  getTemplateLabelValue: (customer_id) =>
    `reports/api/v1/customer/${customer_id}/template/labelvalue/`,
  retrieveTemplate: (customer_id, template_id) =>
    `reports/api/v1/customer/${customer_id}/template/${template_id}/`,
};

const PROBES = {
  getIOTypes: (mac_id) => `system/api/v1/controllers/${mac_id}/sensor/types/`,
  getProbesList: (mac_id, io_type) =>
    `system/api/v1/controllers/${mac_id}/sensor/${io_type}/modes/`,

  getSensorList: (mac_id, io_type, probe_mode) =>
    `system/api/v1/controllers/${mac_id}/sensor/${io_type}/${probe_mode}/sensor/`,
  pins: (mac_id, io_type, probe_mode, sensorId) =>
    `system/api/v1/controllers/${mac_id}/sensor/${io_type}/${probe_mode}/${sensorId}/`,
  sensorTypes: "core/api/v2/sensor-types/",
  sensorGroups: "core/api/v2/sensor-groups/",
};

const SENSOR = {
  sensorDetails: (mac_id, sensor_id) =>
    `system/api/v1/controllers/${mac_id}/sensors/${sensor_id}/config_view/`,
  sensorDetailsEdit: (mac_id, sensor_id) =>
    `system/api/v1/controllers/${mac_id}/sensors/${sensor_id}/config_edit/`,
  sensorDelete: (mac_id, sensor_id) =>
    `system/api/v1/controllers/${mac_id}/sensors/${sensor_id}/`,
  resetLimit: (mac_id, sensor_id) =>
    `system/api/v1/controllers/${mac_id}/sensors/${sensor_id}/limit/`,
  acknowledgePower: (mac_id, sensor_id) =>
    `system/api/v1/controllers/${mac_id}/inventorysensor/${sensor_id}/onoff/`,
  analysis: (mac_id, sensor_id, range, alarm, oprange, xLabel, yLabel) =>
    `system/api/v1/controllers/${mac_id}/sensors/${sensor_id}/analysis/?range=${range}&alarm=${alarm}&oprange=${oprange}&xLabel=${xLabel}&yLabel=${yLabel}`,
  sensorSummary: (mac_id, sensor_id) =>
    `system/api/v1/controllers/${mac_id}/sensors/${sensor_id}/summary/`,
  selectedSensorGroupType: (sensor_id) =>
    `/system/api/v2/inventory-sensors/${sensor_id}/`,
};
const CUSTOMERS = {
  getCustomers: "organization/api/v1/customer/",
  getCustomersLabelValue: "organization/api/v1/customer/labelvalue/",
};

const CONTACTS = {
  getContacts: (id) => `organization/api/v1/customer/${id}/customercontactperson/`,
};

const ALERTS = {
  getAlertsList: "alerts/api/v1/alerts/",
  getSensorAlertsList: "alerts/api/v1/sensor-alerts/",
  downtimeCreateData: "alerts/api/v1/downtime/data_for_create/",
  metricCreateData: "alerts/api/v1/metric/data_for_create/",
  metricFieldOptions: "alerts/api/v1/metric/get_metric_field/",
  createDowntime: "alerts/api/v1/downtime/",
  createMetric: "alerts/api/v1/metric/",
  downtimeGraph: "alerts/api/v1/downtime/plot/",
  sensorDowntimeGraph: "alerts/api/v1/sensor-alerts/plot/",
  metricGraph: "alerts/api/v1/metric/plot/",
  getAlertHistory: (id) => `alerts/api/v1/alerts/${id}/history/`,
  getSensorAlertHistory: (id) => `alerts/api/v1/sensor-alerts/${id}/history/`,
  getAlertHistoryLogs: (id) => `alerts/api/v1/alerts/${id}/logs/`,
  getSensorAlertHistoryLogs: (id) => `alerts/api/v1/sensor-alerts/${id}/logs/`,
  getSensorAlertsOptions: "alerts/api/v1/sensor-alerts/get_sensor/",
  createSensorDowntime: "alerts/api/v1/sensor-alerts/",
  alertHandoff: (id) => `/alerts/api/v1/alerts/${id}/handoff/`,
  sensorAlertHandoff: (id) => `/alerts/api/v1/sensor-alerts/${id}/handoff/`,
};

const TSDB = {
  dashboards: "tsdb/api/v2/dashboards/",
  dashboardDetails: (dashboard_id) => `tsdb/api/v2/dashboards/${dashboard_id}/`,
  dashboardCells: (dashboard_id) => `tsdb/api/v2/dashboards/${dashboard_id}/cells/`,
  dashboardCellsBulkUpdate: (dashboard_id) =>
    `tsdb/api/v2/dashboards/${dashboard_id}/cells/bulk_update/`,
  dashboardCellDetails: (dashboard_id, cell_id) =>
    `tsdb/api/v2/dashboards/${dashboard_id}/cells/${cell_id}/`,
  getQuery: "tsdb/api/v2/query/",
  getDashboardWidgets: (customerId) =>
    `organization/api/v1/customer/${customerId}/widgets/`,
  snapshotHandoff: (dashboardId) => `/tsdb/api/v2/dashboards/${dashboardId}/handoff/`,
  snapshotClone: (dashboardId) => `/tsdb/api/v2/dashboards/${dashboardId}/clone/`,
};

const DATA_EXPLORER = {
  dataExplorerTemplates: "tsdb/api/v2/data-explorer/templates/",
  dataExplorerAnalysis: "tsdb/api/v2/data-explorer/analysis/",
  dataExplorerTimezones: "system/api/v1/data-explorer/timezones/",
  dataExplorerSnapshots: "tsdb/api/v2/dashboards/lookup/",
};

const NOTIFICATIONS = {
  getNotifications: "/notification/api/v1/notification/",
  markAsRead: (id) => `notification/api/v1/notification/${id}/mark_read/`,
  markAllAsRead: "notification/api/v1/notification/mark_all_read/",
  deleteAll: "notification/api/v1/notification/delete_all/",
};

const ADVANCE_TAB = {
  getAdvanceTabProbeTypes: (mac) =>
    `/system/api/v1/controllers/${mac}/advanced/slavechange/`,
  getSlaveList: (mac, probeId) =>
    `/system/api/v1/controllers/${mac}/advanced/slavechange/${probeId}/`,
};

const WEBHOOKS = {
  listWebHooks: "extras/api/v2/webhooks/",
  listWebhookDeliveryLogs: (id) => `extras/api/v2/webhooks/${id}/deliveries/`,
};

const EVENT_RULES = {
  listEventRules: "extras/api/v2/event-rules/",
  eventObjectTypes: "extras/api/v2/event-rules/content-types/",
  eventFieldTypes: "extras/api/v2/event-rules/field-types/",
  eventWebhook: "extras/api/v2/webhooks/choices/",
  controllerSensorData: "extras/api/v2/event-rules/for-devices/",
};

const CLONE_PROFILE = {
  compatibleControllers: "system/api/v1/controllers/compatible-controllers/",
  cloneProfile: (targetMac) => `system/api/v1/controllers/${targetMac}/clone-sensors/`,
  cloneSensorsStatus: (targetMac) =>
    `system/api/v1/controllers/${targetMac}/clone-sensors-status/`,
};

const CUSTOM_FIELDS = {
  customFields: "extras/api/v2/custom-fields/",
  customFieldsForModel: "extras/api/v2/custom-fields/per-model/",
  customFieldChoices: "extras/api/v2/custom-field-choice-sets/",
  customFieldChoicesLabelValue: "extras/api/v2/custom-field-choice-sets/label_value/",
  fieldTypes: "extras/api/v2/custom-fields/field-types/",
  objectTypes: "extras/api/v2/custom-fields/content-types/",
  relatedObjectTypes: "extras/api/v2/custom-fields/related-content-types/",
};

const EXTRAS = {
  scope: "extras/api/v2/scope/",
};

const allPaths = {
  ...AUTH,
  ...SITES,
  ...BASE,
  ...INTERCOM,
  ...SYSTEM,
  ...ADDRESS,
  ...REPORTS,
  ...TEMPLATES,
  ...USERS,
  ...GROUP,
  ...PROBES,
  ...SENSOR,
  ...CUSTOMERS,
  ...CONTACTS,
  ...ALERTS,
  ...TSDB,
  ...DATA_EXPLORER,
  ...NOTIFICATIONS,
  ...ADVANCE_TAB,
  ...WEBHOOKS,
  ...CLONE_PROFILE,
  ...CUSTOM_FIELDS,
  ...EXTRAS,
  ...EVENT_RULES,
};

export const getUrl = (key) => {
  return allPaths[key];
};
